import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { theme, GlobalStyle } from '../../../config/styled';
import { openDatabase, clearBufferMessagesDB } from '../../../db/dbUtils';
import { Toast } from '../../organisms';
import Routes from '../routes';
import 'react-toastify/dist/ReactToastify.min.css';

const App = () => {
  useEffect(() => {
    const initDB = async () => {
      try {
        // Open IndexedDB
        await openDatabase();

        // Clear pending messages buffer
        await clearBufferMessagesDB();
      } catch (error) {
        console.error('Error inicializando IndexedDB:', error);
      }
    };

    initDB();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Routes />
      <Toast />
    </ThemeProvider>
  );
};

export default App;
